import {
  SET_DROP_DOWN_VALUES,
  SET_REDMINE_FIELDS,
  SET_REDMINE_DEFAULT_VALUES,
  DROP_DOWN_VALUES_RETRIEVED,
  SET_PROJECT,
  SET_TEAM_MEMBER_LIST,
  SEARCH_RESULT_LIST,
  SEARCH_RESULT_LIST_SELECTED,
  VENDOR_NAME_TO_ID_MAP,
  VENDOR_ID_TO_NAME_MAP,
  TEAM_MEMBER_ID_TO_NAME_MAP,
  TEAM_LEADER_EMAIL_MAP,
  SHAREPOINT_FOLDER_ID,
  WORKFLOW,
  WORKFLOW_PERMISSION,
  SEARCH_CRITERIA,
  REDMINE_ROLE_ID,
  CUSTOM_FIELD_VISIBILITIES,
  VENDOR_LIST
} from './definition'

export default {
  [SET_DROP_DOWN_VALUES] (state, dropDownValues) {
    for (let property in dropDownValues) {
      if (state[property] && state[property]['list']) {
        state[property].list = dropDownValues[property].list
      }
    }
  },
  [SET_REDMINE_FIELDS] (state, redmineFields) {
    for (let property in redmineFields) {
      if (state[property] && state[property]['field']) {
        state[property].field = redmineFields[property].field
      }
    }
  },
  [SET_REDMINE_DEFAULT_VALUES] (state, redmineDefaultValues) {
    for (let property in redmineDefaultValues) {
      if (state[property] && state[property]['defaultValue'] === null) {
        state[property].defaultValue = redmineDefaultValues[property].defaultValue
      }
    }
  },
  [DROP_DOWN_VALUES_RETRIEVED] (state) {
    state.dropDownValuesRetrieved = true
  },
  [SET_PROJECT] (state, project) {
    state.project.defaultValue = project.id
  },
  [SET_TEAM_MEMBER_LIST] (state, teamMembers) {
    state.teamMembers = teamMembers
  },
  [SEARCH_RESULT_LIST] (state, searchResultList) {
    state.searchResultList = searchResultList
  },
  [SEARCH_RESULT_LIST_SELECTED] (state, searchResultListSelected) {
    state.searchResultListSelected = searchResultListSelected
  },
  [VENDOR_NAME_TO_ID_MAP] (state, vendorNameToIdMap) {
    state.vendorNameToIdMap = vendorNameToIdMap
  },
  [VENDOR_ID_TO_NAME_MAP] (state, vendorIdToNameMap) {
    state.vendorIdToNameMap = vendorIdToNameMap
  },
  [TEAM_MEMBER_ID_TO_NAME_MAP] (state, teamMemberIdToNameMap) {
    state.teamMemberIdToNameMap = teamMemberIdToNameMap
  },
  [TEAM_LEADER_EMAIL_MAP] (state, teamLeaderEmailMap) {
    state.teamLeaderEmailMap = teamLeaderEmailMap
  },
  [SHAREPOINT_FOLDER_ID] (state, sharepointFolderId) {
    state.shaepointFolderId = sharepointFolderId
  },
  [WORKFLOW] (state, workflow) {
    state.workflow = workflow
  },
  [WORKFLOW_PERMISSION] (state, workflowPermission) {
    state.workflowPermission = workflowPermission
  },
  [SEARCH_CRITERIA] (state, searchCriteria) {
    state.searchCriteria = searchCriteria
  },
  [REDMINE_ROLE_ID] (state, redmineRoleId) {
    state.redmineRoleId = redmineRoleId
  },
  [CUSTOM_FIELD_VISIBILITIES] (state, customFieldVisibilities) {
    state.customFieldVisibilities = customFieldVisibilities
  },
  [VENDOR_LIST] (state, value) {
    state.vendorList = value
  }
}



// WEBPACK FOOTER //
// ./src/components/sourcing_workflow/service_request/store/mutations.js